import React from "react";
import { useIntl } from "react-intl";
import detector from "detector";

import { amazonHost } from "../../../../paths";
import { appleStore, googlePlayStore } from "../../../../../common/parameters";
import { IProps } from "./interfaces";

import { AppStoreImage, Container, GooglePlayImage } from "./styles";
import { getAppStoreLocale, getGooglePlayLocale } from "./utils";

const isIos = process.env.WEBPACK && detector.os.name === "ios";
const isAndroid = process.env.WEBPACK && detector.os.name === "android";

const StoreBadges = ({ asMobile, onlyCurrentPlatform }: IProps) => {
    const { locale } = useIntl();
    return (
        <Container asMobile={asMobile}>
            {(!isIos || !onlyCurrentPlatform) && (
                <a href={googlePlayStore} target="_blank">
                    <GooglePlayImage
                        src={`${amazonHost}landing/google-play-badges/${getGooglePlayLocale(locale)}.svg`}
                    />
                </a>
            )}
            {(!isAndroid || !onlyCurrentPlatform) && (
                <a href={appleStore} target="_blank">
                    <AppStoreImage
                        src={`${amazonHost}landing/app-store-badges/${getAppStoreLocale(locale)}.svg`}
                    />
                </a>
            )}
        </Container>
    );
};

export default StoreBadges;